import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
import { Header, Image, Button, Item } from 'semantic-ui-react';
import EntryItem from 'components/EntryItem/index';
import FilterTagBar from 'components/FilterTagBar';
import HashLink from 'components/HashLink';
import './style.css';
// import data from './faq.json';

/* ------------- IMAGES --------------------*/
import imgExtension from './assets/extension-medium.png';
import gifSelectTabsCmd from './assets/select-tabs-cmd.gif';
import gifSelectTabsShift from './assets/select-tabs-shift.gif';
import imgModalTags from './assets/modal-tags.png';
import imgCreateNewTag from './assets/new-tag.png';
import imgDeleteTag from './assets/delete-tag.png';
import imgSortTags from './assets/sort-tags.png';

const getTestIsReadEntry = (isRead) => {
  const title = isRead ? "Now I'm marked as read!"
      : "Try hovering over me! Then click the checkmark to the right.";
  return {
    id: "test",
    title: title,
    url: "/faq",
    faviconUrl: "https://winno.io/favicon.ico?v=2",
    tags: ["faq", "mark-read"],
    isRead: isRead,
    dateAdded: new Date()
  }
}


class FaqPage extends Component {
  state = {
    testIsRead: false,
    testIsDeleted: false
  }

  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    return(
      <section className="faq-page">
        <div className="faq-section">
          <h2>Why use Winno?</h2>
          <div className="section-content-container">
            <div>
              <b>Save what's important</b> with Winno.
            </div>
            <ul>
              <li>
                Maybe it's a <b>great article</b> you want to remember.
              </li>
              <li>
                A website you don't want to forget to look at later.
              </li>
              <li>
                <b>The millions of tabs</b> you have open when you're researching that next trip, project, idea, etc...
              </li>
            </ul>
            <p>
              You can save, organize and sort all that <b>^</b> with Winno to <b>declutter</b> your browser and <b>your mind</b>.
            </p>
          </div>
        </div>

        <div className='faq-section nav'>
          <HashLink to='#How-do-I-add-tabs-urls-articles-etc'>How do I add tabs, urls, articles, etc... ?</HashLink>
          <br />
          <HashLink to='#How-do-I-organize-my-entries'>How do I organize my entries?</HashLink>
            <div className='sub-nav'>
              <HashLink to='#Adding-Tags'>Adding Tags</HashLink>
              <br /> <HashLink to='#Creating-New-Tags'>Create New Tags</HashLink>
              <br /> <HashLink to='#Deleting-Tags'>Delete Tags</HashLink>
              <br /> <HashLink to='#Sorting-by-Tags'>Sort by Tags</HashLink>
            </div>
          <HashLink to='#Mark-your-entries-as-read-or-unread'>How can I mark entries as read or unread?</HashLink>
          <br /> <HashLink to='#How-do-I-delete-an-entry'>How do I delete an entry?</HashLink>
          <br /> <HashLink to='#Edit-multiple-entries-at-once'>Can I edit multiple entries at once?</HashLink>
          <br /> <HashLink to='#Winno-across-devices'>Can I use Winno across devices?</HashLink>
            <div className='sub-nav'>
              <HashLink to='#Mobile-experience'>Mobile Experience</HashLink>
            </div>
          <HashLink to='#Delete-your-account'>How do I delete my account?</HashLink>
          <br /> <HashLink to='#Other-questions'>Other questions, thoughts, requests?</HashLink>
        </div>

        <div id="Getting-Started" className="faq-section">
          <h2 className="ui header">Getting started.</h2>
          <div className="section-content-container">
            <p className="note">
              <span className='side-note'>
                <span className='note-colon'>Note:</span> Winno is currently optimized for{' '}
                <a href="https://www.google.com/chrome/" target="_blank">
                Chrome
              </a>.
            </span>
          </p>
          <ol className="">
            <li>
              Download the Chrome Extension{' '}
              <a
                href="https://chrome.google.com/webstore/detail/ggoaphgimjbbiaikigjgjiggilnlhgcd"
                target="_blank">
                here
              </a>.
            </li>
            <li>
              Login at{' '}
              <a href="https://winno.io" target="_blank">
              winno.io
            </a>.
          </li>
          <li>
            Add your first entry! <i>see below for details...</i>
          </li>
        </ol>
      </div>
    </div>

    <div id="How-do-I-add-tabs-urls-articles-etc" className="faq-section">
      <h2 className="ui header">How do I add tabs, urls, articles, etc...?</h2>
      <div className="section-content-container">
        <p className="note">
          <span>There are two easy ways to add entries to Winno.</span>
        </p>
        <div className="paragraph">
          <div id="1.-Via-the-extension" className="faq-section">
            <h4 className="ui header">1. Via the extension</h4>
            <div className="section-content-container">
              <p className="note">
                <span>
                  <i>We recommend this method, as it's the quickest.</i>
                </span>
              </p>
              <ul className="">
                <li>Simply select the tab you want to save.</li>
                <li>
                  Click the extension icon and press <b>'Add Selected Tabs'</b>.
                  <Image className='offset' src={imgExtension} size='medium' />
                </li>
                <li>
                  You will then be taken to Winno where you can add tags to your
                  entries before you save them.
                </li>
                <li>
                  <span className='note-colon'>Pro Tip: </span>
                  Select multiple tabs at once
                  <ul>
                    <li>
                      Hold down <b>ctrl</b> or <b>cmd ⌘</b> (for Mac) as you select
                      them. As you see below, the selected tabs will be a slightly lighter color
                      than the unselected ones.
                      <Image className='space' src={gifSelectTabsCmd} />
                    </li>
                    <li>
                      <i>OR</i> Select one tab, hold <b>shift</b> while you select another
                      tab and it will select all of the tabs in between the two
                      you selected.{' '}
                      <Image className='space' src={gifSelectTabsShift} />
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div id="2.-Via-the-add-button" className="faq-section">
            <h4 className="ui header">
              2. Via the add button <b>>></b>
              <Button
                className="add-button"
                primary
                circular
                size="huge"
                onClick={() => { }}
                >
                  +
                </Button>
              </h4>
              <div className="section-content-container">
                <ul className="">
                  <li>
                    Click the yellow, circle button, on the bottom right hand of the
                    your home page.
                  </li>
                  <li>
                    Copy and paste in all of the urls you want to add, separated by
                    a comma or space
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="How-do-I-organize-my-entries" className="faq-section">
        <h2 className="ui header">How do I organize my entries?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>
              'Tags' are the primary mechanism to help you sort and organize
              everything in Winno.{' '}
            </span>
            <span>
              You can add any number of tags to anything you store in Winno and then
              filter your entries by those tags from the filter bar.{' '}
            </span>
            <div className='filter-tag-bar'>
              <FilterTagBar placeholder="Filter by tags" tags={[]} handleUpdate={()=>{}}/>
            </div>
            <div id="Adding-Tags" className="faq-section">
              <h4 className="ui header">Adding Tags</h4>
              <div className="section-content-container">
                <p className="note">
                  <span>There are two ways to add tags in Winno.</span>
                </p>
                <ul className="">
                  <li>
                    <b>Via the extension:</b> When you add entries via the
                    extension, Winno will ask you to enter any tags before you save
                    the entry.{' '}
                    <Image src={imgModalTags} size='big'/>
                  </li>
                  <li>
                    <b>Once the entry is saved:</b> At anytime, you can select an
                    entry by first hovering over the entry and clicking the circle
                    outline icon on the left side. Then you can add tags via the
                    dropdown that appears in the yellow edit panel at the top of the
                    page.{' '}
                    <Item.Group unstackable>
                      <EntryItem
                        entry={{
                          id: "test",
                          title: "Try hovering over me! Then select the circle to the left.",
                          url: "/faq",
                          faviconUrl: "https://winno.io/favicon.ico?v=2",
                          tags: ["faq", "hover"],
                          isRead: false,
                          dateAdded: new Date()
                        }}
                      />
                    </Item.Group>
                  </li>
                </ul>
                <p className="note">
                  <span>
                    <b>Tip:</b> you can add tags to multiple entries at once by
                    clicking that same circle icon on all of the entries you want to
                    edit.
                  </span>
                </p>
              </div>
            </div>
            <div id="Creating-New-Tags" className="faq-section">
              <h4 className="ui header">Creating New Tags</h4>
              <div className="section-content-container">
                <div className="paragraph">
                  <span>
                    New tags can be created when you are adding them to an entry
                    from the edit panel. Follow the instructions to add a tag, start
                    typing and then press enter on the option that says '<b>Add</b>{' '}
                    New Tag Name'
                  </span>
                  <Image src={imgCreateNewTag} />
                </div>
              </div>
            </div>
            <div id="Deleting-Tags" className="faq-section">
              <h4 className="ui header">Deleting Tags</h4>
              <div className="section-content-container">
                <div className="paragraph">
                  <span>
                    From the filter bar, hover over the entry you want to delete,
                    and then click the trash icon.
                  </span>
                  <Image src={imgDeleteTag} size='medium'/>
                </div>
              </div>
            </div>
            <div id="Sorting-by-Tags" className="faq-section">
              <h4 className="ui header">Sorting by Tags</h4>
              <div className="section-content-container">
                <div className="paragraph">
                  <span>
                    You can also sort by tags by selecting the tag icon on the right
                    hand side below the filter bar on your home page.
                  </span>
                  <Image src={imgSortTags} size='small'/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="Mark-your-entries-as-read-or-unread" className="faq-section">
        <h2 className="ui header">How can I mark entries as 'read' or 'unread'?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>
              In order to mark entries that you've already looked at or read, but want
              to keep in Winno, simply hover over the entry, and click the check
              icon on the right hand side.{' '}
            </span>
            <span>
              This allows you to then view only your read or unread articles by
              clicking on the filter button on the right hand side of the home page,
              below the filter bar.{' '}
            </span>
            <div className='faq-example'>
              <Item.Group unstackable>
                <EntryItem
                  handleDelete={() => {}}
                  toggleIsRead={() => {
                    this.setState({ testIsRead: !this.state.testIsRead })
                  }}
                  entry={getTestIsReadEntry(this.state.testIsRead)}
                />
              </Item.Group>
            </div>
          </div>
        </div>
      </div>

      <div id="How-do-I-delete-an-entry" className="faq-section">
        <h2 className="ui header">How do I delete an entry?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>
              Simply hover over the entry, and click the trash icon on the right
              hand side.{' '}
            </span>
          </div>
          <div className='faq-example delete'>
            {
              !this.state.testIsDeleted ?
                ( <Item.Group unstackable>
                    <EntryItem
                      handleDelete={() => this.setState({ testIsDeleted: true })}
                      toggleIsRead={() => {}}
                      entry={{
                        id: "test",
                        title: "Try hovering over me, then click the trash can icon.",
                        url: "/faq",
                        faviconUrl: "https://winno.io/favicon.ico?v=2",
                        tags: ["faq", "delete"],
                        isRead: false,
                        dateAdded: new Date()
                      }}
                    />
                  </Item.Group>
                ) : (
                  <Button secondary onClick={() => this.setState({ testIsDeleted: false })}>
                    Wait! Come back!
                  </Button>
                )
            }
          </div>
        </div>
      </div>

      <div id="Edit-multiple-entries-at-once" className="faq-section">
        <h2 className="ui header">Can I edit multiple entries at once?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>
              You can edit multiple entries at once by hovering over an entry,
              clicking the circle icon on the left hand side, an edit panel will
              appear at the top of the page... You can select as many entries as you
              want.{' '}
            </span>
          </div>
        </div>
      </div>

      <div id="Winno-across-devices" className="faq-section">
        <h2 className="ui header">Can I use Winno across devices?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>
              Everything you save in Winno is stored to the cloud, so wherever you
              log in to Winno, your data will be available.
            </span>
            <div id="Mobile-experience" className="faq-section">
              <h4 className="ui header">Mobile experience</h4>
              <div className="section-content-container">
                <div className="paragraph">
                  <span>
                    That being said, the mobile experience for Winno is not great
                    yet, so hang tight for improvements.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="Delete-my-account" className="faq-section">
        <h2 className="ui header">How can I delete my account?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>
              We're sad to lose you, but if you wish to close your account, please
              contact us at <b>contact@winno.io</b>
            </span>
          </div>
        </div>
      </div>

      <div id="Privacy-policy" className="faq-section">
        <h2 className="ui header">What's your privacy policy?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>
              Please see here: <a href='/privacy'> Privacy policy.</a>
            </span>
          </div>
        </div>
      </div>

      <div id="Other-questions" className="faq-section">
        <h2 className="ui header">Other questions, thoughts, concerns, requests?</h2>
        <div className="section-content-container">
          <div className="paragraph">
            <span>We'd love to hear from you...</span>
            <span>
              {' '}
              <b><a href='mailto:contact@winno.io' target='_top'>contact@winno.io</a></b>
            </span>
          </div>
        </div>
      </div>
    </section>
  )
  }
  // const faqs = data.faqs;
  // return (
  //   <section className="faq-page">
  //     {_.map(faqs, (faq, i) => renderSection(faq, i) )}
  //   </section>
  // )
};

export default FaqPage;

const getStrTag = contentType => {
  return contentType === 'div' ? 'span' : 'li';
};



/*----------- Code to convert json to jxx --------------*/

const renderString = (str, contentType, key, content) => {
  const Tag = getStrTag(contentType);
  const link = _.split(str, /[()\][]+/);
  const isLink = link.length > 1;
  let parts = _.split(str, '_');
  let StyleTag = parts.length > 1 ? 'i' : null;
  if (parts.length <= 1) {
    parts = _.split(str, '**');
    StyleTag = parts.length > 1 ? 'b' : null;
  }

  return (
    <Tag key={key}>
      {isLink ? link[0] : parts[0]}
      {StyleTag && <StyleTag>{parts[1]}</StyleTag>}
      {isLink ? <a href={link[2]} target='_blank'>{link[1]}</a> : parts[2]}
      {isLink && link[3]}
      {content && renderContent(content, contentType)}
    </Tag>
  )
};

const renderEntries = (entries, contentType) => {
  return _.map(entries, (entry, i) => {
    if (typeof entry === 'string') {
      return renderString(entry, contentType, i.toString());
    } else {
      return renderSection(entry, i);
    }
  });
};

const renderContent = (content, contentType) => {
  if (!content) return;
  const ContentTagType = `${contentType}`;
  const classes = contentType === 'div' ? 'paragraph' : '';
  return (
    <ContentTagType className={classes}>
      {renderEntries(content, contentType)}
    </ContentTagType>
  );
};

const getHeader = type => {
  const dict = {
    TOP: 'h2',
    SECONDARY: 'h4'
  };
  return dict[type];
};

// If is header, create div, display header, render ontent,
// otherwise renderString, and display content within string tag
const renderSection = (section, i) => {
  const isHeader = !!section.header;
  const id = isHeader ? _.replace(section.header.text, / /g, '-') : '';
  const classes = isHeader ? 'faq-section' : 'faq-sub-section';
  if (isHeader) {
    return (
      <div key={i.toString()} id={id} className={classes}>
        <Header as={getHeader(section.header.type)}>
          {section.header.text}
        </Header>
        <div className="section-content-container">
          {!!section.note && (
            <p className="note">{renderString(section.note, 'div', '')}</p>
          )}
          {renderContent(section.content, section.content_type)}
          {!!section.extra && (
            <p className="note">{renderString(section.extra, 'div', '')}</p>
          )}
        </div>
      </div>
    )
  } else {
    return renderString(section.text, section.content_type, i, section.content)
  }
};



// WEBPACK FOOTER //
// ./src/scenes/FAQ/index.js